import { useEffect, useState } from "react";
import { setMainLoading, setPageTitle } from "../../../Store/reducers/Common";
import { useDispatch, useSelector } from "react-redux";
import { PostAxios, responseCatchFunc } from "../../../Services/RequestService";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { setToastData } from "../../../Store/reducers/Toast";

const DivMaster = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    //const [currentPage, setCurrentPage] = useState(1);
    const [openAddForm, setOpenAddForm] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const BlankDivData = {
        org_id: parseInt(userData.org_id) > 0 ? parseInt(userData.org_id) : 0,
        division_name: '',
        division_number: ''
    }
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
    });
    const [divData, setDivData] = useState(BlankDivData);
    const [isEditing, setIsEditing] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    useEffect(() => {
        dispatch(setPageTitle(`Division Master`));
        PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken).then(({ data }) => {
            if (data.status === '1') {
                setOrgList(data.data);
            }
        })
        fetchDivList();
    }, [accessToken, dispatch])
    const fetchDivList = () => {
        dispatch(setMainLoading(true));
        let postData = {
            org_id: filter.org_id
        }

        postData.page = 1
        postData.perPage = 1000
        PostAxios(`masters/division-list`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setDivList(data.data);
                }
                else {
                    setDivList([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const setEditDiv = (item) => {
        setDivData({
            org_id: item.org_id,
            division_name: item.division_name,
            division_number: item.division_number,
            div_id: item.ID
        });
        setOpenAddForm(true);
        setIsEditing(true);
    }
    return (
        <>
            <div className="main-form-sec">
                <div className="top-right-btn p-0">
                    <button className="btn-blue btn br-0" onClick={() => {
                        setOpenAddForm(!openAddForm);
                        setIsEditing(false);
                        setDivData(BlankDivData);
                    }}>
                        {openAddForm ? 'Close' : (isEditing) ? 'Update Division' : 'Add New'}
                    </button>
                </div>
                <div className={`main-form-sec add-form my-3 ${openAddForm ? 'active-open' : ''}`}>
                    <h4>{openAddForm ? 'Close' : (isEditing) ? 'Update' : 'Add New'} Division</h4>
                    <Formik
                        initialValues={divData}
                        validate={values => {
                            const errors = {};
                            if (!values.org_id && values.org_id === 0) { errors.org_id = 'This field is required'; }
                            if (!values.division_name) { errors.division_name = 'This field is required'; }
                            if (!values.division_number && values.division_number < 1) { errors.division_number = 'This field is required'; }
                            let integerTest = (value) => { return /^-?\d+$/.test(value) };
                            if (!integerTest(values.division_number)) {
                                errors.division_number = 'Division number must be an integer.';
                            }
                            return errors
                        }}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            dispatch(setMainLoading(true));
                            setSubmitting(true);
                            let endpoint = `masters/add-division`;
                            let postData = {
                                org_id: values.org_id,
                                division_name: values.division_name,
                                division_number: parseInt(values.division_number)
                            }
                            if (isEditing > 0) {
                                endpoint = `masters/update-division`;
                                postData.div_id = divData.div_id
                            }
                            PostAxios(endpoint, postData, accessToken).then(({ data }) => {
                                if (data.status === "1") {
                                    dispatch(setToastData({ message: `${data.message}`, isHtml: true, type: 'success', showCloseBtn: true }));
                                    setSubmitting(false);
                                    setDivData(BlankDivData)
                                    fetchDivList();
                                    setIsEditing(false);
                                    resetForm();
                                }
                                else {
                                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'error', showCloseBtn: true }));
                                    setSubmitting(false);
                                    dispatch(setMainLoading(false));
                                }
                            })
                                .catch(err => {
                                    responseCatchFunc(dispatch, err);
                                    dispatch(setMainLoading(false));
                                });
                        }}
                        enableReinitialize
                    >
                        {({ errors, touched, isSubmitting }) => (
                            <Form>
                                <div className="form-sec mt-3">
                                    {
                                        userData.role_slug === "super_admin" &&
                                        <div className={`form-field-group w-25 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                            <div className="w-50">
                                                <label htmlFor="org_id">Organization</label>
                                            </div>
                                            <div className="w-50 input-area">
                                                <Field as="select" className="select-input" id="org_id" name='org_id'>
                                                    <option value="0">Choose Organisation</option>
                                                    {
                                                        orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                                    }
                                                </Field>
                                                <ErrorMessage component="span" name="org_id" className="error-label" />
                                            </div>
                                        </div>
                                    }
                                    <div className={`form-field-group w-25 ${(errors.division_name && touched.division_name) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="division_name">Division Name</label>
                                        </div>
                                        <div className="w-50 input-area">
                                            <Field type="text" className="form-input" id="division_name" placeholder="Division Name" name='division_name' />
                                            <ErrorMessage component="span" name="division_name" className="error-label" />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-25 ${(errors.division_number && touched.division_number) ? 'error-input' : ''}`}>
                                        <div className="w-50">
                                            <label htmlFor="division_number">Division Number</label>
                                        </div>
                                        <div className="w-50 input-area">
                                            <Field type="number" className="form-input" id="division_number" placeholder="Division Number" name='division_number' step="1" />
                                            <ErrorMessage component="span" name="division_number" className="error-label" />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-25`}>
                                        <button type="submit" className="btn btn-blue" disabled={isSubmitting}>Submit</button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="top-reports-filter">
                    <div className={`right-filter-sec`}>
                        <button className="filter-toggle" onClick={() => {
                            setShowFilter(!showFilter);
                        }}>
                            <i className="fa-solid fa-filter"></i>
                        </button>
                        <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                            <div className="report-filter-field">
                                <label className="select-input-outer">Organization</label>
                                <div className="static-items-outer">
                                    <select
                                        id="org_id"
                                        name="org_id"
                                        className="select-input"
                                        value={filter.org_id}
                                        onChange={(e) => setFilter({"org_id":e.target.value})}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            orgList.length > 0 && orgList.map((item, index) => <option key={`org-filter-${index}`} value={item.ID}>{item.short_name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                            <button type="button" className="btn btn-blue ms-2" onClick={() => { fetchDivList(); }}>Submit</button>
                        </div>
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Division Name</th>
                                <th>Division Order</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                divList.length > 0 && divList.map((item, index) => (
                                    <tr key={`org-id-${index}-${item.ID}`}>
                                        <td>{item.division_name}</td>
                                        <td>{item.division_number}</td>
                                        <td>
                                            <button className="btn-blue btn btn-sm" onClick={() => { setEditDiv(item) }}>
                                                <i className="fa-solid fa-pen"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default DivMaster;